import { render, staticRenderFns } from "./JMultiSelectTag.vue?vue&type=template&id=5ade9766"
import script from "./JMultiSelectTag.vue?vue&type=script&lang=js"
export * from "./JMultiSelectTag.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/fb587e26-24b6-43df-a4aa-75cb4eb3f6e2/workspace/aigoes-school-web_Adop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5ade9766')) {
      api.createRecord('5ade9766', component.options)
    } else {
      api.reload('5ade9766', component.options)
    }
    module.hot.accept("./JMultiSelectTag.vue?vue&type=template&id=5ade9766", function () {
      api.rerender('5ade9766', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dict/JMultiSelectTag.vue"
export default component.exports